import { render, staticRenderFns } from "./ProjectImageAdd.vue?vue&type=template&id=6005b976&scoped=true"
import script from "./ProjectImageAdd.vue?vue&type=script&lang=js"
export * from "./ProjectImageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005b976",
  null
  
)

export default component.exports